'use client';

import Image from 'next/image';
import { useEffect, useState } from 'react';

import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogTitle,
} from '@repo/palette';
import { getImageUrl } from '@repo/utils';

interface SuccessProps {
  type: 'brave' | 'phantom' | 'mobile';
}

export const WarningModal: React.FC<SuccessProps> = ({ type }) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const getContent = () => {
    switch (type) {
      case 'brave':
        return {
          title: 'Try a Different Browser',
          description:
            'This page works best on certain browsers. For the smoothest experience, please open it in Chrome, Safari, or Firefox.',
        };
      case 'phantom':
        return {
          title: 'Update Phantom Wallet',
          description:
            'Your Phantom wallet is outdated. Please upgrade to version {MIN_VERSION} or higher to get the best experience.',
        };
      case 'mobile':
        return {
          title: 'Visit on Desktop',
          description:
            'For the smoothest experience, we recommend that you visit this page on a desktop browser.',
        };
    }
  };

  const content = getContent();

  if (!mounted) return null;

  return (
    <Dialog
      defaultOpen
      modal
    >
      <DialogPortal>
        <DialogContent
          hideCloseIcon
          className='bg-background border-border fixed left-[50%] top-[50%] max-w-[400px] translate-x-[-50%] translate-y-[-50%] rounded-xl border p-0'
        >
          <DialogHeader>
            <Image
              width={400}
              height={200}
              src={getImageUrl('/claim/images/warning-image.png')}
              alt='Warning'
              className='rounded-t-xl'
            />
            <DialogTitle className='text-foreground mb-2 font-semibold tracking-wide md:text-[22px]'>
              {content.title}
            </DialogTitle>
            <DialogDescription className='mx-3 mb-2 font-light tracking-wide text-white/40 md:mx-6 md:text-base'>
              {content.description}
            </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <DialogClose className='bg-primary text-primary-foreground mx-6 mb-6 w-full rounded-md px-3 py-2 hover:bg-white/70'>
              Dismiss
            </DialogClose>
          </DialogFooter>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
};
